import {Component, EventEmitter,ViewEncapsulation,Input,Output  } from '@angular/core';

@Component({
  selector: 'ngbd-modal-customclass',
  templateUrl: './modal-customclass.html'
})
export class NgbdModalCustomclass {
	@Input() activeFieldTabType;
	@Input() fieldTabArray;
	@Output() AddMoreOptionsFInsideTab = new EventEmitter();
	@Output() AddOptionsFieldInsideTabs = new EventEmitter();
	@Output() close = new EventEmitter();
  constructor() {
	
  }
  
  AddMoreOptionsFInside(h){
	this.AddMoreOptionsFInsideTab.emit(h);
  }
  AddOptionsFieldInsideTab(){
	this.AddOptionsFieldInsideTabs.emit();
  } 
  close_pop(){
	this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/create/modal-customclass.ts